import { useId } from "react";
import { COLORS, RADIUS } from "../../shared/theme";

/**
 * Pop-in formulaire réutilisable (overlay sombre + carte centrée).
 * Aligné sur le comportement de la page Consentements pour une UX homogène.
 */
export default function FormModal({
  open = true,
  title,
  headerBackground,
  headerColor = "#fff",
  maxWidth = 760,
  children,
  footer,
}) {
  const titleId = useId();

  if (!open) return null;

  const headerBg = headerBackground ?? COLORS.primary;

  return (
    <div
      role="dialog"
      aria-modal="true"
      aria-labelledby={titleId}
      style={{
        position: "fixed",
        inset: 0,
        background: "rgba(15,23,42,0.7)",
        zIndex: 1000,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: 20,
      }}
    >
      <div
        style={{
          background: COLORS.white,
          borderRadius: RADIUS.xl,
          width: "100%",
          maxWidth,
          maxHeight: "90vh",
          display: "flex",
          flexDirection: "column",
          overflow: "hidden",
          boxShadow: "0 24px 80px rgba(0,0,0,0.25)",
        }}
      >
        <div
          id={titleId}
          style={{
            background: headerBg,
            color: headerColor,
            padding: "16px 24px",
            borderRadius: `${RADIUS.xl}px ${RADIUS.xl}px 0 0`,
            flexShrink: 0,
          }}
        >
          <div style={{ fontWeight: 800, fontSize: 14 }}>{title}</div>
        </div>
        <div style={{ padding: 24, overflowY: "auto", flex: 1, minHeight: 0 }}>{children}</div>
        {footer != null ? (
          <div
            style={{
              padding: "14px 24px",
              borderTop: `1.5px solid ${COLORS.border}`,
              flexShrink: 0,
              background: "#fafafa",
            }}
          >
            {footer}
          </div>
        ) : null}
      </div>
    </div>
  );
}
